import type { Ref } from 'vue';
import { ALERT_INSIGHT_DATA, INSIGHT_THRESHOLD } from '@/alert/utils/alertInsight.define';
import type { AlertRuleDetailV9 } from '@/api-client/alert/model';

export const useInsightInfo = () => {
  const getInsight = (category: string, key: string) => ALERT_INSIGHT_DATA.en?.[category]?.[key];

  const setInsightView = (isInsightView: Ref<boolean>, ruleData?: AlertRuleDetailV9 | null) => {
    // ruleData 없음(시스템 알람 등)은 insightView 비활성 상태이므로, null 가드보다 먼저 리셋한다.
    isInsightView.value = false;
    if (!ruleData) return;

    const {
      alertRuleType: ruleType,
      ruleCriteria,
      metricConditions,
      eventConditions,
      lastLevel = 'NORMAL',
    } = ruleData;

    if (lastLevel === 'NORMAL') return;

    if (ruleType?.toLowerCase() === 'event') {
      const eventCondition = eventConditions?.[0];
      const category = eventCondition?.category ?? '';
      const eventName = eventCondition?.variableConditionList?.[0]?.eventName?.[0] ?? '';
      if (!category || !eventName) return;

      if (getInsight(category, eventName)) isInsightView.value = true;
      return;
    }

    if (ruleType?.toLowerCase() === 'metric' && ruleCriteria === 'Check by Target') {
      const metricCondition = metricConditions?.[0];
      const category = metricCondition?.category ?? '';
      const { criticalComparison, alertName, conditionType, dataIds } =
        metricCondition?.threshold ?? {};
      if (!category || !criticalComparison) return;

      if (conditionType === 'formula' && (!dataIds || dataIds?.length !== 1)) return;
      const metricId = conditionType === 'formula' ? dataIds?.[0] : alertName;
      if (!metricId) return;

      const insightData = getInsight(category, metricId);
      if (!insightData) return;

      const allowed = INSIGHT_THRESHOLD[insightData.threshold ?? ''];
      if (allowed?.includes(criticalComparison)) isInsightView.value = true;
    }
  };
  return { setInsightView };
};
